var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    rootBottomBorder: "".concat(borders.widthSmall, " ").concat(borders.style, " ").concat(colors.contrasts.grey1214),
    rootPadding: spacing.medium,
    titleMargin: spacing.small,
    alertWrapperMargin: spacing.small
  };
};
export default generateComponentTheme;